/* eslint-disable react/jsx-no-target-blank */
import React, { useEffect, useState } from "react";
import "./Projects.css";


const Projects = () => {
  const [projects, setProjects] = useState([]);

  const [selectedCategory, setSelectedCategory] = useState("All");
  useEffect(() => {
    fetch("/projects.json")
      .then((res) => res.json())
      .then((data) => setProjects(data));
  }, []);

  const filteredProjects =
    selectedCategory === "All"
      ? projects
      : projects.filter((project) => project.category === selectedCategory);

  // Function to change the selected category
  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };
  return (
    <div id="projects" style={{ marginTop: "70px" }}>
      <div className="heading-section">
        <h4 className="mb-5 fw-bold">My Projects</h4>
      </div>
      <div className="container">
        <div className="mb-5">
          
          <button className=" filterbtn" onClick={(e) => handleCategoryChange("All", e)}>Frontend</button>
          <button className="filterbtn mx-3" onClick={(e) => handleCategoryChange("react", e)}>ReactJs</button>
          <button className="filterbtn " onClick={(e) => handleCategoryChange("nextjs", e)}>NextJs</button>
        </div>
        <div className="row row-cols-1 row-cols-md-3 g-4">
          {filteredProjects?.map((project) => (
            <div key={project.id} className="col ">
            
            <div className="port_con border rounded">
                  <div className="port_img">
                    <img src={project.img} className="w-100" height={200} alt="" />
                    <div className="port_img_overlay">
                    
                    
                      <div className="">
                      <h4>{project.title}</h4>
                      <a className="my-image-links " data-gall="gallery01" href={project.clientCode} target="_blank">
                      <i className="fa-brands fa-github "></i>Github
                      </a>
                      <a className="my-image-links ms-3" data-gall="gallery01" href={project.liveLink} target="_blank">
                      <i className="fa-brands fa-chrome "></i>Live Site
                      </a>
                      <a className="my-image-links ms-3" data-gall="gallery01" href={`/projects/${project.id}`}>
                        <i className="fa-solid fa-link"></i>details
                      </a>
                      </div>
                    </div>
                  </div>
                  <div className="pt-3">
                  <h6>{project?.desc5}</h6>
                  
                </div>
                </div>
                
            </div>
          ))}
        </div>

       
      </div>
    </div>
  );
};

export default Projects;
